import React from "react";
import { Download, Play, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCtaSection() {
  return <section data-section-id="260109" id="צרו-קשר" className="bg-background text-foreground py-24 px-4 md:px-8">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center">
        {}
        <div className="inline-flex items-center rounded-md bg-accent px-4 py-1.5 text-sm font-default font-medium text-accent-foreground mb-8">
          זמינות מיידית
        </div>

        {}
        <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] font-bold text-foreground mb-6 leading-tight tracking-tight">
          צריכים מטפל סיעודי עכשיו?
        </h2>

        {}
        <p className="text-lg md:text-[20px] text-muted-foreground mb-10 max-w-2xl leading-relaxed font-default">
          הורידו את האפליקציה שלנו ומצאו מטפל מקצועי ומסור המגיע עד אליכם תוך 5 שעות בלבד, עם ליווי אישי לכל אורך הדרך.
        </p>

        {}
        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-8 py-6 text-lg h-auto mb-12 shadow-lg shadow-primary/10 transition-all hover:scale-105">
          <Link to="/ContactPage">
            <Download className="mr-2 size-5" />
            הורדת האפליקציה
          </Link>
        </Button>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 w-full sm:w-auto">
          <Button asChild variant="outline" className="h-auto py-2.5 px-6 rounded-md gap-3 border-border hover:bg-accent w-full sm:w-auto justify-start sm:justify-center">
            <Link to="#">
              <Smartphone className="size-7 text-foreground" />
              <div className="text-left">
                <div className="text-[10px] leading-none text-muted-foreground mb-1 uppercase tracking-wider font-default">Download on the</div>
                <div className="text-sm font-semibold leading-none text-foreground font-default">App Store</div>
              </div>
            </Link>
          </Button>
          
          <Button asChild variant="outline" className="h-auto py-2.5 px-6 rounded-md gap-3 border-border hover:bg-accent w-full sm:w-auto justify-start sm:justify-center">
            <Link to="#">
              <Play className="size-7 text-foreground" />
              <div className="text-left">
                <div className="text-[10px] leading-none text-muted-foreground mb-1 uppercase tracking-wider font-default">GET IT ON</div>
                <div className="text-sm font-semibold leading-none text-foreground font-default">Google Play</div>
              </div>
            </Link>
          </Button>
        </div>

        {}
        <p className="text-xs text-muted-foreground font-default font-medium">
          זמין להורדה ב-App Store וב-Google Play • שירות בפריסה ארצית רחבה
        </p>
      </div>
    </section>;
}